import { render, staticRenderFns } from "./PainelDocumentoSolicitadoVisualizacao.vue?vue&type=template&id=28610bdd&scoped=true"
import script from "./PainelDocumentoSolicitadoVisualizacao.vue?vue&type=script&lang=js"
export * from "./PainelDocumentoSolicitadoVisualizacao.vue?vue&type=script&lang=js"
import style0 from "./PainelDocumentoSolicitadoVisualizacao.vue?vue&type=style&index=0&id=28610bdd&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28610bdd",
  null
  
)

export default component.exports